import styled, { keyframes } from 'styled-components'

const display = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`

export const DashboardWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  animation: ${display};
  animation-duration: 1s;
  animation-fill-mode: forwards;
`
